"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _useStyles2 = _interopRequireDefault(require("./useStyles"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Dropdown = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var item = _ref.item;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];

  var activate = function activate() {
    return setActive(true);
  };

  var deactivate = function deactivate() {
    return setActive(false);
  };

  var _useStyles = (0, _useStyles2["default"])({
    columnCount: item.items.length > 5 ? Math.round(item.items.length / 5) : 1
  }),
      dropdownList = _useStyles.dropdownList,
      ul = _useStyles.ul,
      li = _useStyles.li;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    onMouseOver: activate,
    onMouseLeave: deactivate,
    onFocus: activate,
    onBlur: deactivate,
    position: "relative"
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({}, (0, _helpers.getButtonProps)(item), {
    "aria-haspopup": "true",
    "aria-expanded": active,
    color: active ? 'primary' : 'inherit'
  }), item.label), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    mountOnEnter: true,
    unmountOnExit: true,
    timeout: 150,
    "aria-hidden": !active,
    "in": active
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: [dropdownList, ul].join(' '),
    component: "ul",
    position: "absolute",
    pb: 4,
    pt: 2,
    ref: ref
  }, item.items.map(function (sub, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: sub.label.concat(i),
      className: li
    }, /*#__PURE__*/_react["default"].createElement(_core.Fade, {
      "in": true,
      timeout: 1250 + i * 1.35
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({}, (0, _helpers.getButtonProps)(sub), {
      color: "inherit"
    }), sub.label)));
  })))));
});

Dropdown.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: _propTypes["default"].object.isRequired
};
var _default = Dropdown;
exports["default"] = _default;